import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() type:string = '';
  @Input() shape = '';
  @Input() size = '';
  @Input() background = '';
  @Input() align = '';
  @Input() position = '';


  constructor() { }

  ngOnInit(): void {
  }

}
